import { useTranslation } from 'react-i18next';

import { NCCard, NCCard2SectionLayout, NCCardHeader } from '@/components/NCCard/NCCard';
import { HabitatIntactnessExplainerBU } from '@/components/NCExplainers/HabitatIntactnessExplainer';

import { GraphTile } from './components/GraphTile';
import { StatsTile } from './components/StatsTile';

export const HabitatIntactnessCard = () => {
  const { t } = useTranslation();
  return (
    <NCCard explainer={<HabitatIntactnessExplainerBU />}>
      <NCCardHeader
        title={t('shared.ncaDetail.habitatIntactness.evolutionBU.title')}
        className='lg:grid-cols-[1fr_1fr]'
      />
      <NCCard2SectionLayout className='[&>*]:py-8'>
        <GraphTile />
        <StatsTile />
      </NCCard2SectionLayout>
    </NCCard>
  );
};
